import '@/common';

import { createMortgageWidget } from '@/widgets/MortgageWidget';

createMortgageWidget(document.querySelector('#mortgage-widget')!);
